import { render, staticRenderFns } from "./AssignSupervisorAdmin.vue?vue&type=template&id=af51513e&scoped=true&"
import script from "./AssignSupervisorAdmin.vue?vue&type=script&lang=js&"
export * from "./AssignSupervisorAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AssignSupervisorAdmin.vue?vue&type=style&index=0&id=af51513e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af51513e",
  null
  
)

export default component.exports